import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const permissions = ["read", "write", "owner"] as const;
type Permission = typeof permissions[number];
const permission = toObjectMap<Permission>([...permissions]);

const permissionZodSchema = z.enum(permissions);

export { permissions, permission, permissionZodSchema };
export type { Permission };
